export const setProductListLayout = (layout: string) => dispatch => {
    dispatch({ type: 'SET_PRODUCT_LIST_LAYOUT', payload: layout });
};
